module.exports = __webpack_public_path__ + "static/img/9.fa9c85c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/9.png
// module id = 3dA/
// module chunks = 0